import { CellProps } from 'react-table'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { PlainHeader, sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { FaturaList } from '../../core/_models'
import { FaturaActionsCell } from './FaturaActionsCell'
import { SituacaoFaturaBadge } from '../../components/SituacaoFaturaBadge'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const faturaColumns = (t: TFunction): ReadonlyArray<TableColumn<FaturaList>> => [
  // Coluna do botão de expandir (o ModernTable desenha o botão na coluna de id `expand`).
  {
    Header: () => <span className='visually-hidden'>Detalhes</span>,
    id: 'expand',
    cellWidth: '56px',
  },
  // Descrição com a especialidade como apoio; os dois seguem ordenáveis.
  sortableColumn<FaturaList>({
    id: 'descricao',
    useQueryRequest,
    fields: [
      { field: 'descricao', label: t('cols.descricao') },
      { field: 'especialidade.nome', label: t('cols.especialidade') },
    ],
    Cell: ({ row }: CellProps<FaturaList>) => (
      <StackedCell primary={row.original.descricao} secondary={row.original.especialidade?.nome} />
    ),
  }),
  sortableColumn<FaturaList>({
    id: 'empresa.nomeFantasia',
    cellWidth: '200px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'empresa.nomeFantasia', label: t('cols.instituicao') }],
    Cell: ({ row }: CellProps<FaturaList>) => (
      <StackedCell primary={row.original.empresa?.nomeFantasia} />
    ),
  }),
  // Período de competência com a data de geração como apoio; os dois seguem ordenáveis.
  sortableColumn<FaturaList>({
    id: 'mesAno.mes',
    cellWidth: '152px',
    useQueryRequest,
    fields: [
      { field: 'mesAno.mes', label: t('cols.periodo') },
      { field: 'data', label: t('cols.data') },
    ],
    Cell: ({ row }: CellProps<FaturaList>) => {
      const { mesSigla, ano } = row.original.mesAno ?? {}
      return (
        <StackedCell
          tabular
          primary={mesSigla && ano ? `${mesSigla}/${ano}` : undefined}
          secondary={row.original.dataFormatada}
        />
      )
    },
  }),
  sortableColumn<FaturaList>({
    id: 'quantidade',
    cellWidth: '128px',
    hideOnMobile: true,
    align: 'end',
    useQueryRequest,
    fields: [{ field: 'quantidade', label: t('cols.atendimentos') }],
    Cell: ({ row }: CellProps<FaturaList>) => (
      <StackedCell tabular primary={row.original.quantidade} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.valor_total')}</PlainHeader>,
    id: 'valorTotal',
    cellWidth: '128px',
    align: 'end',
    Cell: ({ row }: CellProps<FaturaList>) => (
      <StackedCell tabular primary={row.original.valorTotalFormatado} />
    ),
  },
  sortableColumn<FaturaList>({
    id: 'situacao',
    cellWidth: '128px',
    useQueryRequest,
    fields: [{ field: 'situacao', label: t('cols.situacao') }],
    Cell: ({ row }: CellProps<FaturaList>) => (
      <SituacaoFaturaBadge situacao={row.original.situacao} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '104px',
    align: 'end',
    Cell: ({ row }: CellProps<FaturaList>) => <FaturaActionsCell fatura={row.original} />,
  },
]
